import { MediaNoteApi } from '../../../api/contentLibrary/models/content-library-media.api.model';
import { UserNoteApi } from '../../../api/users/models/user-note.api';



export class UserNoteModel {
    id?: number;
    createdUserId?: number;
    creationDate?: Date;
    creationDateDisplayString?: string;
    value?: string;

    constructor(apiModel: UserNoteApi) {
        if (apiModel) {
            this.id = apiModel.id;
            this.createdUserId = apiModel.createdUserId;
            this.creationDate = new Date(apiModel.creationDate);
            this.value = apiModel.value;
        }
    }

    toApiModel() {
        return {
            createdUserId: this.createdUserId,
            creationDate: this.creationDate.getTime(),
            value: this.value
        };
    }

    toMediaNoteApiModel(): MediaNoteApi {
        return {
            id: this.id,
            note: this.value
        };
    }

    clone() {
        return new UserNoteModel(this.toApiModel());
    }

    equals(other: UserNoteModel) {
        if (!other) {
            return false;
        }

        return (
            this.createdUserId === other.createdUserId
            && this.creationDate.toString() === other.creationDate.toString()
            && this.value === other.value
        );
    }
}
